<script>
    // import './test_autodetect'
    import LicitacionWidget from '$lib/custom/components/LicitacionWidget2.svelte'
    import CubiertaSelector from '$lib/custom/components/CubiertaSelector.svelte';
    import BackDrop from '$lib/components/UI/BackDrop.svelte';
    import ConfirmationButton from '$lib/custom/components/ConfirmationButton.svelte';
    import { DynamicDict }from '$lib/stores/dynamicDict'
    import { writable } from 'svelte/store'
    import InputPrice from '$lib/custom/components/InputPrice.svelte'
    let data = {
        "id_licitacion": "442423977431",
        "id_proveedor_adjudicado": "85c623f9-579c-4956-a786-30a978944857",
        "proveedor_adjudicado": "",
        "fecha_licitacion": "09/12/2024 13:33:53",
        "fecha_vencimiento": "09/12/2024 14:33:53",
        "demora": "12",
        "alcance": 0,
        "jurisdiccion_estricta": true,
        "numero_ofertas": "",
        "diferencia_cotizacion": "",
        "reclamo_activo": false,
        "oferta_ref": "5a6dddf3-a96c-4b16-a761-c97e33c6ee3b",
        "reclamos": [],
        "id_siniestro": "53300011188",
        "patente_vehiculo": "AG390MA",
        "codigo_infoauto": "329999",
        "marca_vehiculo": "PEUGEOT",
        "modelo_vehiculo": "Ejemplo modelo",
        "anio_vehiculo": 2023,
        "nombre_apellido_asegurado": "MESA AGUSTIN IGNACIO",
        "numero_chasis": "8AWDD22H4RA005562",
        "dni_asegurado": "36477698",
        "jurisdiccion": "901",
        "localidad": "CAPITAL FEDERAL",
        "calle": "PARAGUAY  PISO. 7 DPTO. 29",
        "altura": "2848",
        "cp": "1425",
        "ubicacion": "-34.59648969, -58.40787192",
        "celular_asegurado": "156-1606117",
        "descripcion_denuncia": "",
        "items": [
            {
                "categoria": "3",
                "descripcion": "Crique; 16\"; 5 tornillos",
                "cantidad": 1,
                "producto": "3_27"
            },
            {
                "categoria": "3",
                "descripcion": "llanta Aleacion",
                "cantidad": 1,
                "producto": "3_50"
            },
            {
                "categoria": "3",
                "descripcion": "Pirelli; Scorpion ATR; 245/70 R16",
                "cantidad": 2,
                "producto": "3_51"
            },
            {
                "categoria": "3",
                "descripcion": "Pirelli; Scorpion ATR; 245/70 R16",
                "cantidad": 1,
                "producto": "3_13"
            }
        ],
        "motivo_readjudicacion": "",
        "observacion": "",
        "id_tipo_siniestro": 3,
        "telefono_asegurado": "11-61606117",
        "numero_poliza": "5330108239512",
        "item_poliza": "1",
        "seccion_poliza": "4",
        "cobertura_asegurado": "520-RC, ROBO E INCENDIO PARC Y TOT. C-GRANIZO Y DESTRUCCION TOT",
        "id_point": "16783",
        "resolucion_urgente": "N",
        "email_asegurado": "gabriel.shimabuku@socialpath.com.ar",
        "step": "1-4-1-53300011188-1",
        "eventos": [],
        "id": "442423977431",
        "state": "Abierta",
        "licitacion_uuid": "a023a401-564a-4b68-b59a-bf36bf753ce1",
        "sucursal": {
            "id": "d0f4c1cd-b3e2-451b-a332-2a5937c803c7",
            "ubicacion": [
                -34.58180986544022,
                -58.43370957875042
            ],
            "nombre": "Valery"
        },
        "gallery": [],
        "creation_date": "2024-12-09T13:33:22.333654+00:00",
        "modified_date": "2024-12-09T14:00:15.161188+00:00",
        "fecha_modificacion": 1733752815,
        "cuit": "20192583730"
}
const dataItems = writable(data?.items?.map((x, index) => ({ ...x, id: index })) || [])
let datax = {}
$: console.log({datax})
    let list = {brands: {}, collections: {}, sizes: {}}
    let brand = '4', collection = '1', size = '470'
    let name = 'Licitacion - Atributos Neumaticos'
    let desc = ''
    let brands = new DynamicDict(name)
    $: collections = brands.sub(brand)
    $: sizes = collections.sub(collection)
    $: console.log({brand, collection, size})
    let vala = 0
</script>

<!-- <div style="position:absolute">

    <label for="marca">
        Marca[{brand}]:
        <select on:mousedown={() => {collection = null ; size = null}} name="marca" id="marca" bind:value={brand}>
            {#each Object.entries($brands.data || {}) as [label, value] (value)}
            <option value="{value}">{label}</option>
            {/each}
        </select>
    </label>
    <label for="Coleccion">
        Coleccion[{collection}]:
        <select on:click={() => {size = null}} name="Coleccion" id="Coleccion" bind:value={collection}>
            {#each Object.entries($collections.data || {}) as [label, value] (value)}
                <option value="{value}">{label}</option>
            {/each}
        </select>
    </label>
    <label for="sizes">
        Sizes[{size}]:
        <select name="sizes" id="sizes" bind:value={size}>
            {#each Object.entries($sizes.data || {}) as [label, value] (value)}
                <option value="{value}">{label}</option>
            {/each}
        </select>
    </label>
</div> -->


<!-- <CubiertaSelector
    dict={brands}
    bind:marca={brand}
    bind:modelo={collection}
    bind:medida={size}
    bind:descripcion={desc}
/>
<p>{desc}</p> -->
<!-- <BackDrop visible>
    <LicitacionWidget
        dataSource={{
            ...data,
            cuit_ii: JSON.parse(localStorage.getItem('ProviderData')).data.cuit_ii,
        }}
        items={$dataItems}
        bind:data={datax}
    />
</BackDrop> -->
<body>
    
    <!-- <div style="display: block;">
        <InputPrice bind:value={vala}></InputPrice>
    </div> -->
    <ConfirmationButton legend="Esta seguro de que desea enviar la oferta?" label="Enviar data" on:click={() => {alert('OK')}}/>
</body>
<!-- items={$dataItems} -->
<!-- <ItemsStoreFormX edit={true} bind:value={sas}/> -->